import { Injectable, Inject} from '@angular/core';

export  class PolicyBeneficiaryDO {

	public id:Number = null;
	
	public insuredClientId:Number = null;
		
	public typeCd: String = null;
	
	public subTypeCd: String = null;
	
	public firstName: String = null;
	
	public lastName: String = null;
	
		


	public  getId():Number {
		return this.id;
	}

	// public  getObjectName():String {
	// 	return this.PolicyBeneficiaryDO.class.getSimpleName();
	// }

	public  getInsuredClientId():Number {
		return this.insuredClientId;
	}

	public  setInsuredClientId(insuredClientId:Number):void {
		this.insuredClientId = insuredClientId;
	}


	public  setId(id:Number):void {
		this.id = id;
	}
	
}
